/** Maps the company-portal roles API (PROLINE-2589) to the table row shape. */

import { createEmptyPermissions } from "./CreateRole/permissionModules";

export const ROLE_STATUS = {
  enabled: "enabled",
  disabled: "disabled",
};

/** Convert the API's permissions array (13 entries, one per module_name) into
 * the matrix's keyed shape `{ [module_name]: { can_view, can_add, can_edit,
 * can_delete } }`. Missing modules fall back to the all-false defaults. */
export const permissionsArrayToMap = (permissions = []) => {
  const map = createEmptyPermissions();
  (Array.isArray(permissions) ? permissions : []).forEach((entry) => {
    const moduleName = entry?.module_name;
    if (!moduleName || !map[moduleName]) return;
    map[moduleName] = {
      can_view: Boolean(entry.can_view),
      can_add: Boolean(entry.can_add),
      can_edit: Boolean(entry.can_edit),
      can_delete: Boolean(entry.can_delete),
    };
  });
  return map;
};

/** Pagination meta from response headers (axios lowercases header keys). */
export const getCompanyRolesListMeta = (response) => ({
  currentPage: Number(response?.headers?.["current-page"] || 1),
  count: Number(
    response?.headers?.["total-count"] ??
      response?.data?.meta?.total_count ??
      response?.data?.meta?.count ??
      0,
  ),
  pages: Number(response?.headers?.["total-pages"] || 1),
});

export const normalizeCompanyRole = (role = {}) => {
  const attrs = role.attributes || role;

  return {
    id: String(attrs.id ?? role.id ?? ""),
    name: attrs.name ?? "",
    status: attrs.status,
    active: attrs.status === ROLE_STATUS.enabled,
    usersCount: Number(attrs.company_users_count ?? 0),
    systemRole: Boolean(attrs.system_role),
    permissions: attrs.permissions ?? [],
  };
};

export const normalizeCompanyRoles = (list = []) =>
  (Array.isArray(list) ? list : []).map(normalizeCompanyRole);

/** Build the list query params. FE default page size is 50 (per design). */
export const buildCompanyRolesListParams = ({ search, page, pageSize }) => {
  const params = { page, items: pageSize };
  const term = (search || "").trim();
  if (term) {
    params.name = term;
  }
  return params;
};
